export const defaultStyle = {
  Container: "text-green font-Regular text-[36px] px-[20px]   mb-[60px]  tracking-normal leading-1.2 font-thin mt-0 box-border",
  Heading: "flex",
  Content: "border-r-1 border-gray-400 h-73 last:border-none mb-[80px] w-full relative first:pl-[15px] first:pr-[50px] px-[50px] box-border",
  Content2: "text-[14px] font-Regular font-bold font-stretch tracking-[0.022em] mb-[44px] mt-[0px] text-black hover:text-red-700 hover:underline",
  Para2: " text-[21px] text-black hover:text-orange-700 hover:underline font-Regular",
  Button: "flex flex-col items-center justify-center",
  Button2: "font-bold text-lg text-center cursor-pointer uppercase font-Regular bg-purple-900 border-2 rounded-full w-[160px] h-[60px] px-45 py-14  box-border text-white hover:opacity-[70%]",
  ContainerTwo: "pt-[55px] md:pt-[90px] lg:pt-[90px] block box-border pb-[30px] md:pb-[50px] lg:pb-[50px]",
  ContainerThree: " w-full box-border md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto  px-[35px] md:px-[15px] ",
  ContainerFour: "ContainerFour flex box-border md:px-[0px]",
  newsLinksOne: "text-black font-bold tracking-[0.53px] leading-[31.5px]",
  SocialLink: "hidden md:block md:mr-0 w-full",
  leftWrapper: 'leftWrapper w-full relative',
  rightWrapper: 'rightWrapper',
}

export const INNER_BREADCRUMB_INLINE = {
  breadcrumbWrapper: "z-9 bg-black bg-opacity-50 pt-[16px] pb-[12px] absolute left-0 right-0 px-[20px] lg:px-0",
  ContainerTwo: "lg:max-w-lg xl:max-w-[1196px] mx-auto w-full",
}